<script>
export default {
  name: 'Exams',
};
</script>
<template>
  <div class="h-100">
    <div class="container-fluid h-100">
      <router-view />
    </div>
  </div>
</template>
